module.exports = __webpack_public_path__ + "img/upgradeHistory__lose.c03ab17b.png";